import { goRequest } from '../utils/httpClientTs';

export interface EOGroupMember {
  id: string;
  user_id: string;
  user_name: string;
  role_id: string;
  role_name: string;
  start_date: string;
  end_date?: string | null;
}

export interface EOGroup {
  id: string;
  name: string;
  description: string;
  group_type_id: string;
  is_active: boolean;
  members: EOGroupMember[];
}

export interface EOGroupSlot {
  group_type_id: string;
  name: string;
  groups: EOGroup[];
}

export interface CreateEOGroupRequest {
  group_type_id: string;
  name?: string;
}

export const getExecutiveOfficeGroups = (): Promise<EOGroupSlot[]> => {
  return goRequest<EOGroupSlot[]>({
    url: '/api/executive-office/groups',
    method: 'GET',
  });
};

export const createExecutiveOfficeGroup = (
  data: CreateEOGroupRequest
): Promise<EOGroup> => {
  return goRequest<EOGroup>({
    url: '/api/executive-office/groups',
    method: 'POST',
    data,
  });
};
